// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1REMu","colBig":"styles_colBig__mChxq","colSmall":"styles_colSmall__2XEeZ","shopifyNameWrapper":"styles_shopifyNameWrapper__1JhKv"};